import React from 'react';
import { motion } from 'framer-motion';
import { Gift, CheckCircle2 } from 'lucide-react';
const bonuses = [{
  id: 1,
  title: '50 JUGADAS GANADORAS PARA ZURDOS',
  subtitle: 'Secuencias listas para copiar',
  image: 'https://cdn.magicpatterns.com/uploads/ppssyDQbqn13MqiJ8ssy4f/image.png',
  items: ['Saque + víbora', 'Globo + recuperación', 'Smash + cierre', 'Patrones rápidos']
}, {
  id: 2,
  title: 'PLAN DE ENTRENAMIENTO DE 90 DÍAS',
  subtitle: 'Sistema progresivo paso a paso',
  image: 'https://cdn.magicpatterns.com/uploads/4q5fnbjHsGDwLyrW647cXp/image.png',
  items: ['Semana por semana', 'Técnica + Físico', 'Táctica + Mentalidad']
}, {
  id: 3,
  title: 'EL MANUAL DEL ZURDO INCÓMODO',
  subtitle: 'Hacé que los rivales jueguen mal aunque sean técnicamente mejores.',
  image: 'https://cdn.magicpatterns.com/uploads/6jBnmsBG3E6kNMRWbojMv4/image.png',
  items: []
}];
export function Bonuses() {
  return <section className="py-8 px-4 bg-brand-black text-white relative overflow-hidden" data-id="element-15">
      <div className="absolute top-0 right-0 w-72 h-72 bg-brand-green/10 rounded-full blur-[100px] pointer-events-none" data-id="element-16"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-17">
        <div className="text-center mb-6" data-id="element-18">
          <span className="inline-block py-0.5 px-2.5 rounded-full bg-brand-green text-brand-black font-body font-bold text-[10px] tracking-wider uppercase mb-2" data-id="element-19">
            Gratis solo por hoy
          </span>
          <h2 className="font-display text-xl md:text-3xl uppercase" data-id="element-20">
            Además, te llevás <span className="text-brand-green" data-id="element-21">3 BONOS</span>{' '}
            de regalo
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-22">
          {bonuses.map((bono, index) => <motion.div key={bono.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-brand-card border border-white/10 rounded-lg overflow-hidden hover:border-brand-green/40 transition-colors flex flex-col" data-id="element-23">
              {/* Image with gradient fade into card */}
              <div className="relative w-full h-32 overflow-hidden" data-id="element-24">
                <img src={bono.image} alt={bono.title} loading="eager" decoding="async" className="w-full h-full object-cover object-top" data-id="element-25" />
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-brand-card/40 to-brand-card pointer-events-none" data-id="element-26"></div>
              </div>

              <div className="p-3 flex flex-col flex-1 min-w-0 -mt-4 relative z-10" data-id="element-27">
                <div className="flex items-center gap-1.5 mb-1.5" data-id="element-28">
                  <div className="bg-brand-green text-brand-black font-display px-1.5 py-0.5 rounded text-[10px] leading-none" data-id="element-29">
                    BONO {bono.id}
                  </div>
                  <Gift className="w-3 h-3 text-brand-green" data-id="element-30" />
                </div>
                <h3 className="font-display text-xs md:text-sm mb-1 leading-tight uppercase" data-id="element-31">
                  {bono.title}
                </h3>
                <p className="font-body text-[10px] text-gray-400 mb-1.5 font-medium leading-snug" data-id="element-32">
                  {bono.subtitle}
                </p>

                {bono.items.length > 0 && <ul className="space-y-0.5 mt-auto" data-id="element-33">
                    {bono.items.map((item, i) => <li key={i} className="font-body text-[10px] text-gray-300 flex items-center gap-1.5 leading-tight" data-id="element-34">
                        <CheckCircle2 className="w-2.5 h-2.5 text-brand-green shrink-0" data-id="element-35" />
                        <span className="truncate" data-id="element-36">{item}</span>
                      </li>)}
                  </ul>}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}